import { createSlice } from '@reduxjs/toolkit';

export const createListingSlice = createSlice({
  name: 'createListing',
  initialState: {
    currentStep: 1,
    steps: [
      {
        icon: 'map',
        label: 'Select Parcels'
      },
      {
        icon: 'address-card',
        label: 'Listing Details'
      },
      {
        icon: 'signs-post',
        label: 'Selling Options'
      },
      {
        icon: 'dollar-sign',
        label: 'Pricing'
      },
      {
        icon: 'thumbs-up',
        label: 'Done'
      }
    ],
    uploadedImages: [],
    landParcels: [],
    selectedLandParcels: [],
    location: null,
    zoom: 16
  },
  reducers: {
    nextStep: state => {
      if (state.currentStep < state.steps.length) {
        state.currentStep += 1;
      }
    },
    prevStep: state => {
      if (state.currentStep > 1) {
        state.currentStep -= 1;
      }
    },
    addImage: (state, action) => {
      const image = action.payload;
      state.uploadedImages = [image, ...state.uploadedImages];
    },
    removeImage: (state, action) => {
      const id = action.payload;
      state.uploadedImages = state.uploadedImages.filter(img => img.id !== id);
    },
    setLocation: (state, action) => {
      state.location = action.payload;
    },
    setZoom: (state, action) => {
      state.zoom = action.payload;
    },
    toggleSelectLandParcel: (state, action) => {
      const parcel = action.payload;
      if (state.selectedLandParcels.find(p => p.id === parcel.id)) {
        state.selectedLandParcels = state.selectedLandParcels.filter(
          p => p.id !== parcel.id
        );
      } else {
        state.selectedLandParcels = [parcel, ...state.selectedLandParcels];
      }
    },
    addDrawnLandParcel: (state, action) => {
      const parcel = action.payload;
      state.landParcels = [parcel, ...state.landParcels];
      state.selectedLandParcels = [parcel, ...state.selectedLandParcels];
    },
    removeDrawnLandParcel: (state, action) => {
      const parcel = action.payload;
      state.selectedLandParcels = state.selectedLandParcels.filter(
        p => p.id !== parcel.id
      );
      state.landParcels = state.landParcels.filter(p => p.id !== parcel.id);
    },
    reset: state => {
      state.uploadedImages = [];
      state.landParcels = [];
      state.selectedLandParcels = [];
      state.currentStep = 1;
      state.zoom = 16;
    },
    setLandParcels: (state, action) => {
      const drawnLandParcels = state.landParcels.filter(p => p.isDrawn);
      const newLandParcels = action.payload;
      state.landParcels = [...drawnLandParcels, ...newLandParcels];
    }
  }
});

export const {
  setLocation,
  setZoom,
  toggleSelectLandParcel,
  addDrawnLandParcel,
  removeDrawnLandParcel,
  setLandParcels,
  nextStep,
  prevStep,
  reset,
  addImage,
  removeImage
} = createListingSlice.actions;
export default createListingSlice.reducer;
